import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { OnCallOverrideAddComponent } from './on-call-override-add.component'

const ON_CALL_OVERRIDE_ADD_ROUTES: Routes = [{
    path: '', component: OnCallOverrideAddComponent
}];

export const ON_CALL_OVERRIDE_ADD_ROUTING  = RouterModule.forChild(ON_CALL_OVERRIDE_ADD_ROUTES);